"use client";

import { cn, Table } from "@kyan/ui";

import { EmptyState } from "#/components/Contents/components/EmptyState/EmptyState";
import { usePositionsDrawerMarket } from "#/store/app/positionsDrawer/positionsDrawerMarket";
import { useSharePnlCardsModal } from "#/store/app/sharePnlCardModal/sharePnlCardsModal";
import { usePositions } from "#/store/wallet/account/positions";

import { getColumns } from "./PerpPositions.constants";

export interface PerpPositionsProps {
  isAllVariant?: boolean;
  isPortfolioVariant?: boolean;
}

export const PerpPositions: React.FC<PerpPositionsProps> = ({
  isAllVariant,
  isPortfolioVariant,
}) => {
  const { open } = useSharePnlCardsModal();
  const { market } = usePositionsDrawerMarket();
  const { positions } = usePositions();

  const perpPositions = positions.filter(
    (position) => position.instrumentType === "perps",
  );
  const isEmpty = !perpPositions.length;

  const columns = getColumns({ openSharePnlCardsModal: open });

  return (
    <Table
      data={perpPositions}
      hideHeader={isAllVariant}
      columns={columns.filter(
        (column) =>
          isAllVariant ??
          !["gamma", "vega", "theta", "rho"].includes(column.id),
      )}
      emptyState={
        <EmptyState
          underlying={market.underlying}
          className="border-divider border-t"
          shouldShowAction={isPortfolioVariant}
          description={`Your ${market.underlying} perp positions will show here`}
        />
      }
      classes={{
        wrapper: cn("bg-background", { "h-full": isEmpty }),
        table: cn({
          "border-b-0": isAllVariant || (isEmpty && !isPortfolioVariant),
          "flex h-full flex-col": isEmpty,
        }),
        thead: "bg-buttonBg",
        tbody: cn("text-textPrimary", {
          "flex-1": isEmpty,
        }),
        row: "bg-background h-8.25",
        cellClassName: "py-1.5",
        loading: {
          skeleton: "h-3",
        },
      }}
    />
  );
};
